import { lazy } from 'react'

import { ERoutePaths, type TRoutePageType } from './types'

const Home = lazy(() => import('pages/Home'))
const Events = lazy(() => import('pages/Events'))
const Error = lazy(() => import('pages/Error'))

const routesList: TRoutePageType[] = [
  {
    element: Home,
    path: ERoutePaths.Home,
    title: 'Home',
  },
  {
    element: Events,
    path: ERoutePaths.Events,
    title: 'Home',
  },
  {
    element: Error,
    path: ERoutePaths.Error,
    title: 'Error',
  },
]

export default routesList
